<template>
  <BreadCrumb PageTitle="Editors" />
  <ListGroup />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ListGroup from "../../template-components/UIElements/ListGroup/ListGroup.vue";

export default defineComponent({
  name: "ListGroupPage",
  components: {
    BreadCrumb,
    ListGroup,
  },
});
</script>